export default {"src":"/_next/static/media/cart-shape2.6b6662b2.svg","height":23,"width":24,"blurWidth":0,"blurHeight":0};